module.exports = __webpack_public_path__ + "static/media/Designing Your Personal Brand.80b17ab1.png";